import React, { useCallback } from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import { FormattedMessage, useIntl } from "react-intl";

import { Button, Modal } from "@mapmycustomers/ui";

import groupFieldInfoModal from "@app/assets/integrations/groupFieldInfoModal.png";
import layout from "@app/styles/layout";

import styles from "./GroupFieldInfoModal.module.scss";

interface Props {
  onHide: () => void;
  visible: boolean;
}

const GroupFieldInfoModal: React.FC<Props> = ({ onHide, visible }) => {
  const intl = useIntl();

  const handleInfoClick = useCallback(() => {
    onHide();
    window.open(
      "https://support.mapmycustomers.com/hc/en-us/articles/360047494774-Groups-Overview"
    );
  }, [onHide]);

  return (
    <Modal
      footer={
        <Row gutter={layout.spacerL} justify="end">
          <Col>
            <Button onClick={handleInfoClick} type="link">
              <FormattedMessage
                id="integrations.groupFieldInfoModal.footer.whatAreCustomFields"
                defaultMessage="What are Groups?"
                description="Text of information link button"
              />
            </Button>
          </Col>
          <Col>
            <Button key="submit" onClick={onHide} type="primary">
              <FormattedMessage
                id="integrations.groupFieldInfoModal.footer.gotIt"
                defaultMessage="Got it!"
                description="Text of GOT IT button"
              />
            </Button>
          </Col>
        </Row>
      }
      onCancel={onHide}
      title={intl.formatMessage({
        id: "integrations.groupFieldInfoModal.title",
        defaultMessage: "Creating groups during an integration",
        description: "Title Group field info modal",
      })}
      visible={visible}
      zIndex={1500}
    >
      <div>
        <p className={styles.paragraph}>
          <FormattedMessage
            id="integrations.groupFieldInfoModal.body.paragraph1"
            defaultMessage="When mapping fields, you can opt to simultaneously create Groups. When “Create Groups” is activated for a given field, Groups are created for any records that have the same value."
            description="Group Field Info Modal first paragraph"
          />
        </p>
        <img alt="groupFieldInfoModal" className={styles.image} src={groupFieldInfoModal} />
        <p className={styles.paragraph}>
          <FormattedMessage
            id="integrations.groupFieldInfoModal.body.paragraph2"
            defaultMessage="Opting to create a group from the field “Status” creates groups for each unique status. For instance, if 2 incoming records have values of “Active” and 3 incoming records have a value of “Inactive”, two groups will be created and titled “Active” and “Inactive” respectively."
            description="Group Field Info Modal second paragraph"
          />
        </p>
        <p className={styles.paragraph}>
          <FormattedMessage
            id="integrations.groupFieldInfoModal.body.paragraph3"
            defaultMessage="All records with those values will be grouped together going forward. Note, after your integration syncs for the first time, you can edit the name or assigned color by accessing Plan > Groups from the menu."
            description="Group Field Info Modal third paragraph"
          />
        </p>
      </div>
    </Modal>
  );
};

export default GroupFieldInfoModal;
